import React from "react";
import { useSelector } from "react-redux";
import Icon from "@mui/material/Icon";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Shown instead of a page that needs a Slack workspace and channel when the
// organization the admin is acting in has none yet.
function NoWorkspace() {
  const { admin, organization } = useSelector((state) => state.auth);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox display="flex" flexDirection="column" alignItems="center" textAlign="center" mt={8}>
        <Icon fontSize="large" color="secondary" sx={{ opacity: 0.5 }}>
          workspaces
        </Icon>
        <SuiTypography variant="h5" fontWeight="medium" mt={1}>
          {organization?.name || "This organization"} has no workspace yet
        </SuiTypography>
        <SuiTypography variant="button" color="text" fontWeight="regular" mt={1}>
          {admin?.is_platform_admin
            ? "Move a Slack workspace into it from the Organizations page, or switch to another organization."
            : "Ask a platform admin to attach a Slack workspace to your organization."}
        </SuiTypography>
      </SuiBox>
    </DashboardLayout>
  );
}

export default NoWorkspace;
